<template>
  <div class="util-dialog">
    <header class="v-mb-10 v-flex">
      <span class="required">工具栏</span>
      <el-switch class="v-ml-10" v-model="runtimeConfig.openTool"></el-switch>
    </header>
    <div class="v-mb-10">快捷回复</div>
    <tableRender :columns="columns" :data="tableData">
      <template #replyText="{row}">
        <el-input
          type="textarea"
          :rows="3"
          maxlength="500"
          placeholder="请输入自动回复文案"
          v-model="row.replyText"
        ></el-input>
      </template>

      <template #open="{row}">
        <el-switch class="v-ml-10" v-model="row.open"></el-switch>
      </template>
    </tableRender>
    <footer class="v-flex-right v-mt-20">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" @click="submit">确定</el-button>
    </footer>
  </div>
</template>
<script>
import TableRender from '@meta-vue/table-render'
import * as Events from '@/constant/events'
import ImSetting from '@/pages/im/plugins/im-setting.js'

export default {
  name: 'workbench-util-dialog',
  components: { TableRender },
  data() {
    return {
      runtimeConfig: ImSetting.getRuntimeConfig(),
      columns: [
        {
          label: '快捷名称',
          width: 100,
          prop: 'label'
        },
        {
          label: '快捷按钮',
          width: 80,
          prop: 'hotkeysDesc',
          slotRender(h, { row }) {
            return <span style="color:#1F5DE9">{row.hotkeysDesc}</span>
          }
        },
        {
          label: '自动回复文案',
          prop: 'replyText',
          slotRender: 'replyText'
        },
        {
          label: '状态',
          prop: 'open',
          slotRender: 'open',
          align: 'center',
          width: 70
        }
      ]
    }
  },
  computed: {
    tableData() {
      return [this.runtimeConfig.firstReceiveConfig, this.runtimeConfig.todoConfig]
    }
  },

  methods: {
    cancel() {
      this.$parent?.hide?.()
    },
    async submit() {
      try {
        await ImSetting?.save(this.runtimeConfig)
        this.cancel()
        Events.emit(Events.WORKBENCH_UTIL_OPTIONS_EVENT, { type: 'refresh' })
        this.$message.success('保存成功')
      } catch (error) {
        console.error('设置缓存失败', error)
        this.$message.error('保存失败')
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.util-dialog {
  margin-top: -10px;
  .required{
    &:before {
      content: '*';
      color:red;
      font-size: 20px;
      line-height:12px;
    }
  }
}
</style>
